import { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";

const FeaturedProducts = () => {
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const products = [
    {
      title: "Condenser",
      description:
        "A device that releases heat from the refrigerant, cooling it back into a liquid.",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi13PMzf7RHFElhFyesl83Ww0CKWPuoWXyma7vnC2Xgvhdl4FUwkfHZZipq_V06BrPOgYHOuPYc7xUKDitTkAEUjRlz_fR1jRFnbOpmz7XSjE_Q8igINfz-ungaxNINU3UvCGhRrO0TdeKZTGRDZEcKS1QJnKy_Zp_caBERP6FV_9JPOZ9peDaeup7g-8s/s350/Chilled%20(2).png",
    },
    {
      title: "Cold Room Evaporator",
      description:
        "Cold Room Evaporator absorbs heat inside a cold room, keeping it cool.",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgt_bu54jijUe7GoZQRB-9ScXkGilotWyIMbf1cCJPSqByMd1fgMto9MKBzjivmz7dJk9EBv5PJbVrlmkU83WqeY7aKaawnLwxuOa_2XH9K8S2v89iP0pAWlzz0DK9jj1cidoZ6cdaj5eTu90aP45UOmfMn8zX-jUw7vhlLMtjU1zHrjmkJu4aF7i9DK9c/s320/Chilled%20(4).png",
    },
    {
      title: "Condensing unit",
      description:
        "Condensing Unit is a system that converts refrigerant from gas to liquid, facilitating heat removal.",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhZf_5j710av2ov0XMVX0drCYi-slp3-f4_DSDWS8Qpu92QSYdGY7S_GRRsXJxDKqaNG4VyCwxrvtPElQwy_P9YExdLqqhih1hPn0fVNug1crdkDAAz2t6pqi_0HBwDNNjJaQcZ7UT2mQ4k1bOB5iiCmK5IhUl7DvlDNGQEgeDxlOFQw0okr1c5-9_bO_Q/s320/Chilled%20(5).png",
    },
    {
      title: "AHU Evaporators",
      description:
        "AHU Evaporators Coils in air handling units that cool the air by absorbing heat.",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi-YUdRgnhKyv9fBrPJSUtqw7uQDBbaFqUSlDXBc1SzC3-NePZToBh__XRlvJfj4u01TX6CpEGgJRRd1oQiepKz6AMxzntQR2Yp4ZoJtiANT0bVWQR6xJgIHQxBOXu817J9da1oD1_mSd5OAqYBOSMCtAe1t7LxEWQbRlrphAivxO05viHRDr_LUmSTk1Q/s320/Chilled%20(6).png",
    },
    {
      title: "Chilled water coil",
      description:
        "Chilled Water Coil that uses chilled water to cool the air in HVAC systems.",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhRoKlg8msR7YyYBtXoLIFi_PXV2ydjKcFcFrR8JqsWXXX_i2mSttNJ5DnRspFqfQejDXvJgFPo9i904ZSMHIBPCk0vE2cDnR-8koq-eokwNrta9APYf4riUif-Y3_4LZMfAyKLxdc8DP4TICmfHci-iORSQoi6R-Nhxn0iHauLQJpP9R-2bGvMnjEeHUc/s320/Chilled%20(3).png",
    },
  ];

  const CARD_WIDTH = 320;

  const scroll = (dir) => {
    if (!sliderRef.current) return;

    sliderRef.current.scrollBy({
      left: dir === "left" ? -CARD_WIDTH : CARD_WIDTH,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollLeft = sliderRef.current.scrollLeft;
      const index = Math.round(scrollLeft / CARD_WIDTH);
      setActiveIndex(index);
    };

    const el = sliderRef.current;

    el?.addEventListener("scroll", handleScroll);

    return () => el?.removeEventListener("scroll", handleScroll);
  }, []);

  const goToSlide = (i) => {
    sliderRef.current.scrollTo({
      left: i * CARD_WIDTH,
      behavior: "smooth",
    });
  };

  return (
    <section className="py-14 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-4xl font-bold text-[#256ab7]">
            Featured Products
          </h2>

          <p className="text-gray-500 mt-4 leading-7">
           Engineered for performance and built for durability, our featured HVAC coil solutions deliver reliable cooling and heating efficiency for industrial and commercial applications.
          </p>
        </div>

        {/* Arrows */}
        <div className="flex justify-end gap-3 mt-10">
          <button
            onClick={() => scroll("left")}
            className="w-11 h-11 rounded-full bg-gray-100 hover:bg-black hover:text-white transition-all"
          >
            ←
          </button>

          <button
            onClick={() => scroll("right")}
            className="w-11 h-11 rounded-full bg-gray-100 hover:bg-black hover:text-white transition-all"
          >
            →
          </button>
        </div>

        {/* Slider */}
        <div
          ref={sliderRef}
          className="flex gap-6 mt-8 overflow-x-auto scroll-smooth snap-x snap-mandatory no-scrollbar"
          style={{
            scrollbarWidth: "none",
          }}
        >
          {products.map((item, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -6 }}
              transition={{ duration: 0.3 }}
              className="min-w-[320px] bg-slate-100 rounded-3xl overflow-hidden snap-start shadow-sm"
            >
              <div className="overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-64 object-cover hover:scale-110 transition duration-500"
                />
              </div>

              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-900">
                    {item.title}
                  </h3>

                </div>

                <p className="text-gray-500 text-sm leading-6 mt-3">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {products.map((_, i) => (
            <button
              key={i}
              onClick={() => goToSlide(i)}
              className={`rounded-full transition-all duration-300 ${
                activeIndex === i
                  ? "w-7 h-2 bg-black"
                  : "w-2 h-2 bg-gray-300"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;